import * as THREE from 'three';
import { gsap, Power4 } from "gsap";
import { vDefaultShader, fInfoShader } from '../shaders';

export class InfoPanel {
    constructor({ assets, model }) {
        this._isOpen = false;
        const infoGeom = new THREE.PlaneGeometry(1, 1)
        const infoMat = new THREE.ShaderMaterial({
            uniforms: {
                time: { value: 0 },
                noiseMap: { value: assets.textures.noise },
                scale: { value: new THREE.Vector2(2, 2) },
            },
            vertexShader: vDefaultShader,
            fragmentShader: fInfoShader,
            transparent: true,
            depthTest: false,
        })

        this.infoDomElement = document.querySelector('.info-panel');
        this.infoStagger = document.querySelectorAll('.info-stagger');

        this.infoHolder = new THREE.Mesh(infoGeom, infoMat);
        this.infoHolder.position.set(0, 0, -0.003)

        model.add(this.infoHolder);
    }

    toggle() {
        this[this._isOpen ? 'hide' : 'show']();

        // state switch doesn't fire until the tween is complete
        // but we want to return the new state immediately
        return this._isOpen;
    }

    show() {
        this._isOpen = true;

        this.updateUI({
            infoHolderX: this.infoOpenPosition,
            infoDomX: window.innerWidth - this.infoPanelWidth,
            direction : "open"
        });
    }

    hide() {
        this._isOpen = false;

        this.updateUI({
            infoHolderX: this.infoClosedPosition,
            infoDomX: window.innerWidth,
            direction : "close"
        });
    }

    updateUI({ infoHolderX, infoDomX, direction, onComplete }) {
        const tweenProps = { duration: 1.5, ease: Power4.easeInOut };
        
        // Cancel any existing tweens
        gsap.killTweensOf(this.infoHolder.position);
        gsap.killTweensOf(this.infoDomElement);

        gsap.to(this.infoHolder.position, {
            ...tweenProps, x: infoHolderX, onComplete,
        });

        gsap.to(this.infoDomElement, {
            ...tweenProps, x: infoDomX, onComplete,
        });
        
        if (direction == "open"){
            gsap.from(this.infoStagger, {
                ease: Power4.easeOut,
                duration: 1.5,
                y: 40,
                delay: .6,
                opacity: 0,
                stagger: .06,
            })
        }
    }

    update(time) {
        this.infoHolder.material.uniforms.time.value = time;
    }

    resize(w, h) {

        gsap.set(this.infoDomElement, {
            x: (this._isOpen) ? window.innerWidth - this.infoPanelWidth : window.innerWidth,
        });

        this.infoHolder.scale.y = h;
        this.infoHolder.scale.x = ( ( this.infoPanelWidth + 200) * w) / window.innerWidth; 
        this.infoOpenPosition = 0.05 + w / 2 - this.infoHolder.scale.x / 2;
        this.infoClosedPosition = 0.05 + w / 2 + this.infoHolder.scale.x / 2;

        this.infoHolder.position.x = (this._isOpen) ? this.infoOpenPosition : this.infoClosedPosition;
    }

    get infoPanelWidth() {
        return this.infoDomElement.getBoundingClientRect().width;
    }

    get active() {
        return this.infoHolder && this._isOpen;
    }
}